import React from 'react';
import { Button, DatePicker, Radio, Select } from 'antd';
import dayjs from 'dayjs';

const { Option } = Select;

const FILTERS = [
  { label: 'Today', value: 'today' },
  { label: '7D', value: '7d' },
  { label: '30D', value: '30d' },
  { label: 'Custom', value: 'custom' },
];

const AnalyticsFilters = ({
  filter,
  setFilter,
  customRange,
  setCustomRange,
  selectedUsers,
  setSelectedUsers,
  selectedTeams,
  setSelectedTeams,
  users,
  teams,
  onRefresh,
  isAdmin,
  isTeamLead,
  usersLoading = false,
  teamsLoading = false
}) => {
  return (
    <div className="analytics-filters">
      <Radio.Group
        options={FILTERS}
        onChange={e => setFilter(e.target.value)}
        value={filter}
        optionType="button"
        buttonStyle="solid"
      />
      {filter === 'custom' && (
        <DatePicker.RangePicker
          value={customRange}
          onChange={v => setCustomRange(v)}
          style={{ marginLeft: 12 }}
          disabledDate={(current) => {
            // Disable dates more than 60 days ago or future dates
            const now = dayjs();
            const sixtyDaysAgo = now.subtract(60, 'days');
            return current && (current.isBefore(sixtyDaysAgo, 'day') || current.isAfter(now, 'day'));
          }}
          placeholder={['Start Date', 'End Date']}
          format="MMM D, YYYY"
        />
      )}
      {/* User Filter - show for both admins and team leads */}
      {(isAdmin || isTeamLead) && (
        <Select
          style={{ width: 200, marginLeft: 12 }}
          placeholder="Filter by user(s)"
          value={selectedUsers || []}
          onChange={(value) => setSelectedUsers(value || [])}
          mode="multiple"
          allowClear
          showSearch
          loading={usersLoading}
          disabled={usersLoading}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          maxTagCount={2}
          maxTagTextLength={10}
          notFoundContent={usersLoading ? 'Loading users...' : 'No users found'}
        >
          {users.map(user => (
            <Option key={user.id} value={user.id}>{user.full_name}</Option>
          ))}
        </Select>
      )}
      {/* Team Filter - show for both admins and team leads */}
      {(isAdmin || isTeamLead) && (
        <Select
          style={{ width: 200, marginLeft: 12 }}
          placeholder="Filter by team(s)"
          value={selectedTeams || []}
          onChange={(value) => setSelectedTeams(value || [])}
          mode="multiple"
          allowClear
          showSearch
          loading={teamsLoading}
          disabled={teamsLoading}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          maxTagCount={2}
          maxTagTextLength={10}
          notFoundContent={teamsLoading ? 'Loading teams...' : 'No teams found'}
        >
          {teams.map(team => (
            <Option key={team.id} value={team.id}>{team.name}</Option>
          ))}
        </Select>
      )}
      <Button onClick={onRefresh} style={{ marginLeft: 16 }}>
        Refresh Analytics
      </Button>
    </div>
  );
};

export default AnalyticsFilters;
